import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_369: DocMigration = {
  maxSchemaVersion: "0.0.369",
  description: "Fix bad default values from duplicating option sets",
  apply(json: any) {
    const optionSetIdsByDefaultValues = {};
    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];
      if (!["true", "false"].includes(optionSet.defaultValue)) {
        if (!optionSetIdsByDefaultValues[optionSet.defaultValue]) {
          optionSetIdsByDefaultValues[optionSet.defaultValue] = [];
        }
        optionSetIdsByDefaultValues[optionSet.defaultValue].push(optionSetId);
      }
    }

    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];
      const options: any[] = Object.values(optionSet.options);
      const optionIds = options.map((option) => option.id);
      if (!optionIds.includes(optionSet.defaultValue)) {
        const matchingOptionSetIds = optionSetIdsByDefaultValues[optionSet.defaultValue];

        let updatedDefaultValue: string | undefined;

        // We can only match the mapped default value by name, we will only attempt it if there is one match
        if (matchingOptionSetIds?.length === 1) {
          const matchingOptionSet = json.optionSets[matchingOptionSetIds[0]];
          const matchingOption = matchingOptionSet.options[optionSet.defaultValue];
          if (matchingOption) {
            const mappedOption = options.find((o) => o.name === matchingOption.name);
            updatedDefaultValue = mappedOption?.id;
          }
        }

        // If we cant map back to the original option, pick the first one as the default
        if (!updatedDefaultValue) {
          const sortedOptions = options.sort((a, b) => a.sortIndex - b.sortIndex);
          updatedDefaultValue = sortedOptions[0]?.id;
        }

        optionSet.defaultValue = updatedDefaultValue;
      }
    }

    return json;
  },
};

export default migration_0_0_369;
